import { Component, inject } from '@angular/core';
import { AuthService } from '@app/components/login.component';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { ActionResult, NtapGlobalConstants, Util } from '@ntap/core';
import { EMPTY, Observable, map, switchMap } from 'rxjs';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';
import { CommonConfirmActionService } from '@app/services/common-confirm-action.service';
import { isDisabledActionForNerazvrstano } from '@app/shared/util/jedinica-gradiva-security-utils';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';

@Component({
  selector: 'app-verificiraj',
  templateUrl: '../common-confirm-action-template.html'
})
export class VerificirajActionComponent extends withTooltipState(
  ItemsListActionComponent
) {
  private authService = inject(AuthService);
  public commonConfirmActionService = inject(CommonConfirmActionService);

  allSelectedVerifiable: any;
  allSelectedUnverifiable: any;

  private lockedJediniceOznake: string[] = [];
  private jediniceWithNoRights: string[] = [];

  key: string = 'verify' + this.toString;

  public override doExecute(): Observable<ActionResult> {
    return this.commonConfirmActionService.confirm(this.key).pipe(
      switchMap(({ confirmed, addPodjedinice }) => {
        if (confirmed) {
          return super.doExecuteWithParams({
            $addPodjedinice: addPodjedinice
          });
        }
        return EMPTY;
      })
    );
  }

  protected override initDisabledObservable() {
    this.isDisabled$ = this.authService.validUser$.pipe(
      switchMap((user) => {
        return this.listViewProvider.selectedItems$.pipe(
          map((selectedItems) => {
            this.lockedJediniceOznake = [];
            this.jediniceWithNoRights = [];

            const isDisabledBecauseSystem =
              isDisabledActionForNerazvrstano(selectedItems);

            if (isDisabledBecauseSystem) {
              this.setTooltip(
                'Granu nerazvrstanog gradiva nije moguće verificirati.'
              );
              return true;
            }

            this.allSelectedVerifiable = selectedItems.every((item: any) => {
              const jedinica = item as JedinicaGradiva;
              const arhivistiIds =
                (jedinica[
                  'en~jedinica_gradiva~arhivist_na_obradi'
                ] as number[]) || [];
              const voditeljiIds =
                (jedinica['en~jedinica_gradiva~voditelj_obrade'] as number[]) ||
                [];
              const oznaka = jedinica['en~jedinica_gradiva~arhivska_oznaka'];
              const mainType =
                item[NtapGlobalConstants.ATTR_$itemType] ||
                item[NtapGlobalConstants.ATTR_$mainType];

              const disabled =
                !AuthService.userIsAdminOrVoditeljZbirki(user) &&
                arhivistiIds.indexOf(user.userId?.value) === -1 &&
                voditeljiIds.indexOf(user.userId?.value) === -1;
              if (disabled) {
                this.jediniceWithNoRights.push(oznaka);
              }

              const statusObradeValue =
                item[Util.getFullAttrName(mainType, 'status_obrade')];

              return statusObradeValue === 'ZA_VERIFIKACIJU' && !disabled;
            });

            let tooltip: string | undefined = this.action.description;
            if (this.lockedJediniceOznake.length > 0) {
              tooltip = `Jedinica ${this.lockedJediniceOznake.join(
                ','
              )} je zaključana za obradu. Kontaktirajte zaduženog voditelja.`;
            }
            if (this.jediniceWithNoRights.length > 0) {
              tooltip =
                (tooltip ?? '') +
                `Nemate prava uređivanja jedinice ${this.jediniceWithNoRights.join(
                  ','
                )}. Kontaktirajte zaduženog voditelja.`;
            }
            this.setTooltip(tooltip);

            return selectedItems.length <= 0 || !this.allSelectedVerifiable;
          })
        );
      })
    );
  }
}
